import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import CheckoutButton from "./CheckoutButton";

const ITEMS = [
  "Ebook principal (150+ recetas)",
  "Menús por edad",
  "Guía nutricional",
  "Planificador semanal",
  "Lista inteligente de compras",
  "Guía visual de porciones",
  "30 snacks saludables",
  "Acceso inmediato",
];

export default function OfferStack() {
  return (
    <section
      data-testid="offer-stack-section"
      className="bg-[#FBF4E7] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left: Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <img loading="lazy" decoding="async"
              src="/img/mockup-bonos.webp"
              alt="Ebook + 4 bonos exclusivos: planificador semanal, lista de compras, guía de porciones y 30 snacks saludables"
              className="w-full h-auto drop-shadow-[0_30px_70px_rgba(78,60,40,0.18)]"
            />
          </motion.div>

          {/* Right: Checklist */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
              Acceso completo
            </p>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl tracking-tight leading-[1.05] text-[#2A302A]">
              Lo que recibirás <em className="italic">hoy</em>.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-[#576057]">
              Ebook + 4 bonos exclusivos, listos para descargar al instante.
            </p>

            <ul className="mt-8 space-y-3.5">
              {ITEMS.map((it, i) => (
                <motion.li
                  key={it}
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.4, delay: 0.05 * i }}
                  data-testid={`offer-item-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="w-6 h-6 rounded-full bg-[#849983]/15 flex items-center justify-center shrink-0 mt-[2px]">
                    <Check className="h-3.5 w-3.5 text-[#849983]" strokeWidth={2.6} />
                  </span>
                  <span className="text-[15px] md:text-base text-[#2A302A] leading-snug">
                    {it}
                  </span>
                </motion.li>
              ))}
            </ul>

            <div className="mt-9">
              <CheckoutButton
                label="SÍ, QUIERO ALIMENTAR MEJOR A MI HIJO"
                testId="offer-stack-cta"
                size="xl"
                fullWidthMobile
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
